module.exports = __webpack_public_path__ + "img/1F1FE-1F1F9.dd99b1d2.svg";